export default __webpack_public_path__ + "static/media/arrow.3f1f31dd.svg";